import microuniversoApi from "app/api/microuniversoApi"
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse"
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container"
import { removerComponenteReact, renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact"
import { Separador } from "app/components/separador/Separador"
import { useAppSelector } from "app/redux/hooks"
import { Parametro } from "app/types/Parametro"
import { tratamentoErroPadrao } from "app/use-cases"
import { obterParametros } from "app/use-cases/parametro/obterParametros"
import { Dict } from "app/utils/Dict"
import globalMU from "globalMU"
import React, { useCallback, useEffect, useRef, useState } from "react"
import { ProdutoLoteContainer } from "./produto-lote/ProdutoLoteContainer"
import { DadosProdutoControleLote, ProdutosControleLote } from "./ProdutosControleLote"


export type ProdutosControleLoteContainerProps = {
    passos: Dict<string, () => void>,
    onVoltar: () => void,
}

export const ProdutosControleLoteContainer = (props: ProdutosControleLoteContainerProps) => {

    const orcamento = useAppSelector((store) => store.orcamento);
    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

    const [dadosControleLote, setDadosControleLote] = useState<PagedMessageResponse<DadosProdutoControleLote>>({})
    const [parametrosCarregados, setParametrosCarregados] = useState(false)

    const isMounted = useRef(true)

    const obterParametrosControleLote = async (): Promise<Parametro[]> =>
        await obterParametros({
            nomes: [
                "CONTROLE_VALIDADE_PRODUTOS",
            ],
        })

    const onObterDadosControleLote = async () => {
        try {
            globalMU.blockUI()
            const resposta = await microuniversoApi.Orcamento.produtosControleLote(orcamento.IdentificadorOrcamento)

            if (isMounted.current) {
                setDadosControleLote(resposta)
            }
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
        }
    }

    const onVoltar = useCallback(() => {
        props.onVoltar()
    }, [props.onVoltar])

    const onPassoSelecionado = useCallback((passo: string) => {
        passosInterno.current.get(passo)()
    }, [])

    const onFuncaoRetornaPagina = useCallback(() => {
        /*
        renderizarComponentReact(<ProdutosControleLoteContainer {...props} />, "conteudo-pagina", true)
        */
        props.onVoltar()
    }, [props.onVoltar])

    useEffect(() => {
        isMounted.current = true

        const carregar = async () => {
            // O rótulo do passo sai do RETORNO do await, não de um state: antes
            // `atualizarParametros()` era disparado sem await e o `valorParametro` era lido na linha
            // seguinte, quando `parametros` ainda era [] — então "CONTROLE_VALIDADE_PRODUTOS" nunca
            // era "S" e o passo era SEMPRE "Produtos com Controle de Lote", em qualquer cliente.
            const parametrosObtidos = await obterParametrosControleLote()

            const usaControleValidade =
                parametrosObtidos.find((p) => p.Nome == "CONTROLE_VALIDADE_PRODUTOS")?.Valor == "S"

            if (!isMounted.current) return

            passosInterno.current.set(
                usaControleValidade
                    ? "Produtos com Controle de Lote/Validade"
                    : "Produtos com Controle de Lote",
                onFuncaoRetornaPagina
            )

            await onObterDadosControleLote()

            if (isMounted.current) {
                setParametrosCarregados(true)
            }
        }

        carregar()

        return () => {
            isMounted.current = false
        }
    }, [])

    return (
        <>
            {parametrosCarregados &&
                <>
                    <Breadcrumb2Container
                        passos={passosInterno.current.keysToList()}
                        id="ProdutosControleLoteContainer"
                        exibirBotaoLimpar={false}
                        exibirBotaoVoltar={true}
                        onBotaoVoltarClicado={onVoltar}
                        onPassoSelecionado={onPassoSelecionado}
                    />

                    <br />

                    <ProdutosControleLote
                        onReservarLote={(codigoObjetoItemOrcamento) => {
                            renderizarComponentReact(<ProdutoLoteContainer
                                identificadorItem={codigoObjetoItemOrcamento}
                                onVoltar={onFuncaoRetornaPagina}
                                passos={passosInterno.current}
                            />, "conteudo-pagina", true)
                        }}
                        dadosProdutoControleLote={dadosControleLote}
                    />
                </>
            }
        </>
    )
}